import { SubNavLink } from '@salecycle/ui-component-library';
import { useFeatureFlags, usePermissions } from 'core/app/AppContext';
import { Permission } from 'entities/user';
import React from 'react';
import { NavLink } from 'react-router-dom';

interface IProps {
  permissions: Permission[];
  featureFlag?: string;
  to: string;
  icon: string;
  exact?: boolean;
  label: string;
}

export const AuthorisedSubNavLink: React.FC<IProps> = (props: IProps) => {
  const { hasPermissionsAll } = usePermissions();
  const { flagEnabled } = useFeatureFlags();

  let enabled = hasPermissionsAll(props.permissions);
  if (props.featureFlag) {
    enabled = flagEnabled(props.featureFlag);
  }
  return enabled ? (
    <NavLink aria-label={props.label} to={props.to} exact={props.exact ?? false}>
      <SubNavLink icon={props.icon}>{props.label}</SubNavLink>
    </NavLink>
  ) : null;
};
